
import { apiSlice } from "../stores/base/api-slice";
import type { FeatureFlagClientSettings } from "../tenant/branding/types";

export interface BrandingCurrency {
	code: string;
	name: string;
	id: string;
}

export interface BrandingCountry {
	code: string;
	name: string;
	id: string;
}

export interface Branding {
	appPrimaryColor: string;
	appSecondaryColor: string;
	appAccentColor: string;
	logo?: string;
	name: string;
	language: string;
	currency: BrandingCurrency;
	country: BrandingCountry;
	// Deployment-wide Flagsmith client settings; absent on an older backend.
	featureFlags?: FeatureFlagClientSettings;
}

// Mocked per tenant for testing — mirrors the mobile app's BrandingApiService mock.
// const MOCK_BRANDING: Record<string, Branding> = {
// 	aedc: { appPrimaryColor: "#081F5C", appSecondaryColor: "#081F5C" },
// 	lepp: { appPrimaryColor: "#081F5C", appSecondaryColor: "#E99935" },
// 	ekedc: { appPrimaryColor: "#ED3237", appSecondaryColor: "#2C2768" },
// };

const brandingEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		// name is the tenant's utility name (e.g. ekedc / aedc / lepp).
		getBranding: builder.query<Branding, string>({
			// Mocked for testing — uncomment the real query below once the backend
			// endpoint exists, and delete this queryFn.
			// queryFn: async () => {
			// 	await new Promise(resolve => setTimeout(resolve, 2000));
			// 	// Simulating an error response for now, to test the retry dialog.
			// 	return { error: { status: 500, data: "Failed to load branding" } };
			// 	// return { data: MOCK_BRANDING[name] ?? MOCK_BRANDING.ekedc };
			// },

			query: name => ({
				url: `/utilityconfigurations/${name}/branding`,
				method: "GET",
			}),
		}),
	}),
});
export const { useGetBrandingQuery, useLazyGetBrandingQuery } = brandingEndpoints;
